import { createConnectQueryKey } from '@connectrpc/connect-query'
import {
  createDemandProcurementMaster,
  listDemandProcurementMasters,
} from '@ebalance/proto/bffuser/v1/occto_master_service-OcctoMasterService_connectquery'

import {
  type InvalidatingMutationResultFor,
  useInvalidatingMutation,
} from '~/hooks/useInvalidatingMutation'

/**
 * 需要調達計画マスタ 新規登録 mutation hook。
 * onSuccess で listDemandProcurementMasters を invalidate してテーブルを最新化する。
 */
export function useCreateDemandProcurementMaster(): InvalidatingMutationResultFor<
  typeof createDemandProcurementMaster
> {
  return useInvalidatingMutation(createDemandProcurementMaster, [
    createConnectQueryKey({
      schema: listDemandProcurementMasters,
      cardinality: 'finite',
    }),
  ])
}
